<template>
  <vf-loader
    class="fixed-0 z-overlay m-a bg-black/75 c-white"
    style="border-radius: 1rem; width: 9rem; height: 9rem"
  />
</template>
